import React from 'react';
import { Box } from '@mui/material';

import { BaseComponent } from '../Component';

export interface AppHeader2Component extends BaseComponent {
  type: 'appHeader2';
  props: AppHeader2Props;
}
export interface AppHeader2Props {
  avatarName: string;
}

export const AppHeader2: React.FC<AppHeader2Props> = ({ avatarName }) => {
  console.log(avatarName);

  return <Box>{avatarName}</Box>;
};
